import axios from '../index';

export const requestAuthLogin = ({ username, password }) =>
  axios.post('/oauth/token', { username, password });
